import clsx, { type ClassValue } from 'clsx'

/** Tiny className combiner. clsx is enough for our needs (no Tailwind merge). */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs)
}
